export default {
  '404': '很抱歉！您访问的页面不存在或者权限不足',
  el: {
    colorpicker: { confirm: '确定', clear: '清空' },
    datepicker: {
      now: '此刻',
      today: '今天',
      cancel: '取消',
      clear: '清空',
      confirm: '确定',
      selectDate: '选择日期',
      selectTime: '选择时间',
      startDate: '开始日期',
      startTime: '开始时间',
      endDate: '结束日期',
      endTime: '结束时间',
      prevYear: '前一年',
      nextYear: '后一年',
      prevMonth: '上个月',
      nextMonth: '下个月',
      year: '年',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      week: '周',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六'
      },
      months: {
        jan: '一月',
        feb: '二月',
        mar: '三月',
        apr: '四月',
        may: '五月',
        jun: '六月',
        jul: '七月',
        aug: '八月',
        sep: '九月',
        oct: '十月',
        nov: '十一月',
        dec: '十二月'
      }
    },
    select: {
      loading: '加载中',
      noMatch: '无匹配数据',
      noData: '无数据',
      placeholder: '请选择'
    },
    cascader: {
      noMatch: '无匹配数据',
      loading: '加载中',
      placeholder: '请选择',
      noData: '暂无数据'
    },
    pagination: {
      goto: '前往',
      pagesize: '条/页',
      total: '共 {total} 条',
      pageClassifier: '页'
    },
    messagebox: {
      title: '提示',
      confirm: '确定',
      cancel: '取消',
      error: '输入的数据不合法!'
    },
    upload: {
      deleteTip: '按 delete 键可删除',
      delete: '删除',
      preview: '查看图片',
      continue: '继续上传'
    },
    table: {
      emptyText: '暂无数据',
      confirmFilter: '筛选',
      resetFilter: '重置',
      clearFilter: '全部',
      sumText: '合计'
    },
    tree: { emptyText: '暂无数据' },
    transfer: {
      noMatch: '无匹配数据',
      noData: '无数据',
      titles: ['列表 1', '列表 2'],
      filterPlaceholder: '请输入搜索内容',
      noCheckedFormat: '共 {total} 项',
      hasCheckedFormat: '已选 {checked}/{total} 项'
    },
    image: { error: '加载失败' },
    pageHeader: { title: '返回' },
    popconfirm: { confirmButtonText: '确定', cancelButtonText: '取消' },
    empty: { description: '暂无数据' }
  },
  login: {
    user: '用户名',
    account: '账号',
    password: '密码',
    signin: '登录',
    signtitle: '用户登录',
    forgetpassword: '忘记密码',
    regsiter: '开发者注册',
    accountLogin: '账号登录',
    codeTips: '校验码短信已发送，有效时间为30分钟，请及时查收。',
    wechartLogin: '微信登录',
    phoneLogin: '手机号登录',
    wetChatTips: '请使用微信扫描二维码登录'
  },
  common: {
    retrieveAfterSeconds: ' 秒',
    getVerificationCode: '获取验证码',
    uploadCompanyLogo: '上传头像图片支持JPG、PNG格式!',
    uploadCompanyLogoSize: '上传头像图片大小不能超过2MB!',
    uploadAvaterTips: '头像支持JPG、PNG格式，且大小不超过2M',
    uploadSuccess: '上传成功',
    uploadFail: '上传失败',
    i18nKey: 'i18nKey',
    i18nKeyRequire: '请输入i18nKey',
    sys: '厦门熵基科技快速开发平台前端框架',
    add: '新增',
    search: '查询',
    edit: '编辑',
    release: '发布',
    update: '修改',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定',
    selectDate: '选择日期',
    select: '请选择',
    success: '成功',
    fail: '失败',
    remark: '备注',
    status: '状态',
    name: '名称',
    statusRequire: '请选择状态',
    remarkRequire: '请输入备注',
    nameRequire: '请输入名称',
    confirmDelete: '确认删除？',
    successDelete: '删除成功',
    cancelDelete: '已取消删除',
    addUser: '添加用户',
    addSuccess: '添加成功',
    inputUserName: '请输入用户名',
    sourceList: '源列表',
    targetList: '目的列表',
    addUserSuccess: '添加用户成功',
    selectUser: '请先选择用户后，再进行操作',
    confirmDeleteUserTip: '您确定删除选中的用户？',
    startTime: '开始时间',
    startTimePla: '请输入开始时间',
    endTime: '结束时间',
    endTimePla: '请输入结束时间',
    userNamePla: '请输入账号',
    logNamePla: '请输入日志名称',
    logType: '日志类型',
    select1record: '请点击表格选中记录!',
    confirmDeleteRecordTip: '您确定删除选中的记录？',
    operation: '操作',
    errorNotice: '错误提示',
    warningNotice: '温馨提示',
    timeSnyc: '同步中...',
    allSelect: '全选',
    deleteFail: '删除失败',
    versionInfo: '变更历史',
    signin: '登录',
    languages: '语言',
    zh_cn: '简体中文',
    en: '英文',
    logout: '退出登录',
    console: '控制台',
    platform: 'Smart DBS',
    userLogin: '用户登录',
    action: '操作',
    requestError: '请求错误',
    requestServiceError: '请求服务异常',
    importedDate: '导入时间',
    extModifiedDate: '第三方修改时间',
    lastUpdateTimeStamp: '最后修改时间',
    createdDate: '创建时间',
    createdBy: '创建者',
    modifiedDate: '修改时间',
    modifiedBy: '修改者',
    enterValue: '请输入内容',
    searchValue: '搜索',
    type: '类型',
    Label: '备注',
    Enabled: '是否启用',
    selectRecod: '请选择数据',
    notice: '提示',
    save: '保存',
    cancelOperation: '取消操作',
    refresh: '刷新',
    saveSucess: '保存成功!',
    lastupdateTime: '最后修改时间',
    statisticalInfo: '统计信息',
    yes: '确 认',
    not: '取 消',
    active: '激活',
    unActive: '未激活',
    tip: '温馨提示',
    details: '详情',
    download: '导出所有设备',
    loginLoading: '正在加载中，请您耐心等待',
    apiDoc: '文档',
    sessionTimeOut: '会话超时，页面将跳转到登录页面',
    send: '发送',
    sunday: '星期日',
    monday: '星期一',
    tuesday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saturday: '星期六',
    updateSuccess: '更新成功',
    loading: '加载中',
    inputKeyWord: '请输入关键字',
    reset: '重置',
    copyRightInfo: 'Copyright © 2021 ZKTECO CO.',
    noPhoto: '没有对应的核验照片',
    isNoEmpty: '请输入值',
    emailValid: '请输入正确的邮箱格式',
    httpValid: '请输入正确的网址格式',
    phoneValid: '请输入正确的手机格式',
    maxPhoneLen: '超过最大长度11',
    stringInRange: '字符串长度必须在 {start} 到 {end}之间',
    validatorInputLength: '请输入少于{len}个字符',
    alreadyBindEmail: '该邮箱已被绑定',
    alreadyBindPhone: '该手机号已被绑定',
    employeeNoTips: '工号支持数字、字母的组合',
    chooseOptions: '请选择',
    emailCodes: '请填写您收到的邮箱验证码',
    noData: '暂无数据'
  },
  user: {
    accountByLogin: '登录账号',
    dbsPrivacy: '《Smart DBS隐私权政策》',
    agree: '我同意',
    useEmailReg: '使用邮箱注册',
    usePhoneReg: '使用手机注册',
    pwdStrength: '密码强度',
    week: '弱',
    middle: '中',
    hight: '高',
    expirationDate: '有效期限',
    noConfirmedPwd: '确认密码不能为空',
    emailCodeError: '输入的验证码不正确，请重新再试',
    sureEmailTip: '请输入正确邮箱',
    onceLogin: '立即登录',
    baseInfo: '基本信息',
    activation: '点击获取',
    userNameTips: '请填写未被熵基科技设备平台注册的用户名',
    emailTips: '请填写未被熵基科技设备平台注册的邮箱',
    emailCode: '验证码',
    inputEmailCode: '请输入验证码',
    emailCodeTips: '点击获取验证码后将收到验证邮件，请回填邮件中的6位验证码',
    inputPwdTips: '密码必须包含数字和字母,且长度在8到16位密码之间',
    services: '《第三方开发者服务协议》',
    regsiter: '注册',
    hasAcount: '已有开发者帐号？',
    startTime: '注册开始时间',
    endTime: '注册结束时间',
    superAdmin: '超级管理员',
    account: '账号',
    status: '状态',
    userName: '用户名称',
    password: '密码',
    confirmedPwd: '确认密码',
    email: '邮箱',
    phone: '手机',
    sex: '性别',
    nickName: '昵称',
    department: '部门',
    role: '角色',
    roleManagement: '角色管理',
    registerTime: '注册时间',
    inputAccount: '请输入账号/手机号/邮箱',
    inputForgetName: '请输入账号',
    inputName: '请输入姓名',
    inputPwd: '请设置密码',
    inputPwd2: '请输入密码',
    input2ndPwd: '请再次输入密码',
    pwdInconsistent: '两次密码输入不一样',
    inputEmail: '请输入邮箱',
    inputPhone: '请输入手机',
    inputNickName: '请输入昵称',
    selectStatus: '请选择状态',
    addUser: '新增用户',
    modifyUser: '修改用户',
    userDetail: '用户详情',
    select1record: '请点击表格选中一条记录！',
    notAllowToChange: '超级管理员不允许修改！',
    notAllowToRemove: '超级管理员不允许删除！',
    notAllowToResetPwd: '超级管理员不允许重置密码！',
    notAllowToFreeze: '超级管理员不允许冻结！',
    confirmDelete: '确认删除？',
    deleteUser: '删除用户',
    confirmDeleteTip: '您确定要删除账号为：| 的用户吗？',
    confirmResetPwd: '重置密码',
    confirmResetPwdTip: '您确定要将账号为：| 的用户密码重置为12345678吗？',
    successResetPwd: '重置密码成功',
    cancelResetPwd: '取消重置密码',
    confirmFreeze: '冻结用户',
    confirmFreezeTip: '您确定要将账号为：| 的用户冻结吗?',
    successFreeze: '冻结用户成功',
    cancelFreeze: '取消冻结用户',
    notNeedUnfreeze: '当前用户已启用，无需解除冻结',
    confirmUnfreeze: '解除冻结',
    confirmUnfreezeTip: '您确定要将账号为：| 的用户解除冻结吗?',
    successUnfreeze: '解除冻结用户成功',
    cancelUnfreeze: '取消解除冻结用户',
    roleAllot: '角色分配',
    findPwdByPhone: '使用手机找回',
    findPwdByEmail: '使用邮箱找回',
    resetPwdSuc: '密码重置成功',
    goBackStep: '上一步',
    welcomeReg: '欢迎注册',
    registerSuccess: '注册成功!立即跳转到登录页面',
    sendCodeSuccess: '成功发送验证码!',
    recoverPassword: '找回密码',
    userNameNotEmpty: '用户名不能为空',
    passwordNotEmpty: '密码不能为空',
    next: '下一步',
    code: '验证码',
    codeError: '验证码错误',
    requireCode: '请输入验证码',
    codeNotEmpty: '验证码不能为空',
    goSign: '跳转到登录页',
    add: '员工新增',
    delete: '员工删除'
  },
  department: {
    addDept: '新增部门',
    updateDept: '编辑部门',
    parentDept: '父级部门',
    deptName: '部门名称',
    deptStatus: '部门状态',
    nameRequire: '请输入部门名称',
    notDeleteRoot: '根部门不允许删除！',
    notDeleteDept: '此部门含有子部门，不能删除！',
    confirmDeleteDeptTip: '您确定删除此部门？',
    selectDept: '请先选择部门后，再进行操作'
  },
  area: {
    addArea: '新增区域',
    updateArea: '编辑区域',
    parentArea: '父级区域',
    areaName: '区域名称',
    areaStatus: '区域状态',
    nameRequire: '请输入区域名称',
    notDeleteRoot: '根区域不允许删除！',
    notDeleteArea: '此区域含有子区域，不能删除！',
    confirmDeleteAreaTip: '您确定删除此区域？',
    selectArea: '请先选择区域后，再进行操作'
  },
  resource: {
    resourceName: '资源名称',
    sortNo: '排序',
    resourceEvent: '按钮事件',
    resourceType: '类型',
    notDeleteRoot: '不允许删除根资源',
    notUpdateRoot: '不允许修改根资源',
    addResource: '添加资源',
    updateResource: '更新资源',
    confirmDeleteTip: '您确定要删除资源：',
    icon: '图标',
    routerName: '路由名称',
    btnGroup: '组名',
    urlRequire: '请输入URL',
    routerNameRule: '与开发配置路由名称相同',
    btnGroupRequire: '请输入按钮组名称',
    btnTypeRequire: '请选择按钮类型',
    btnStyleRequire: '请选择按钮样式',
    btnType: '按钮类型',
    btnStyle: '按钮样式',
    btnEffect: '按钮效果',
    parentResource: '父级资源',
    default: '默认按钮',
    primary: '主要按钮',
    success: '成功按钮',
    text: '文本',
    info: '信息按钮',
    warning: '警告按钮',
    danger: '危险按钮',
    plain: '朴素按钮',
    round: '圆角按钮',
    circle: '圆形按钮',
    typeRequire: '请选择资源类型',
    sortNoRequire: '请输入序号',
    intRequire: '请输入正整数',
    parentRequire: '请选择父级资源',
    parentRule1: '父级资源不允许是资源自身',
    parentRule2: '父级资源不允许是本资源的子级资源',
    resourceEventRequire: '请输入按钮事件',
    disabled: '禁用'
  },
  role: {
    addRole: '添加角色',
    addRoleGroup: '添加角色组',
    role: '角色',
    addRoleSuccess: '角色新增成功',
    updateRoleSuccess: '角色修改成功',
    roleGroup: '角色组',
    roleName: '角色名称',
    roleGroupName: '角色组名称',
    roleGroupNameRequire: '请输入角色组名称',
    roleGroupRequire: '请选择角色组',
    roleNameRequire: '请输入角色名称',
    noGroup: '暂不分组',
    confirmDeleteTip: '您确认要删除此用户角色?',
    confirmDeleteGroupTip: '您确认要删除此用户角色组?',
    addUser: '添加成员',
    authorization: '授权',
    authorizeSuccess: '授权成功',
    authorizeFail: '授权失败',
    selectRoleToAddUserTip: '请在左侧选择需要添加用户的角色',
    selectRoleToAuthorizeTip: '请在左侧选择授权的角色',
    selectUser: '请选择用户',
    confirmDeleteUserTip: '您确认要移除:|的用户角色',
    notDeleteAdmin: '超级管理员下的admin用户不允许删除！'
  },
  param: {
    paramType: '参数类型',
    paramName: '参数名称',
    paramValue: '参数值',
    sortNo: '排序值',
    paramStatus: '参数状态',
    addParam: '新增系统参数',
    updateParam: '修改系统参数',
    confirmDeleteTip: '您确定删除此系统参数？',
    typeRequire: '请输入系统参数类型',
    nameRequire: '请输入参数名称',
    valueRequire: '请输入系统参数值'
  },
  dictionary: {
    name: '名称',
    type: '类型',
    dictName: '字典名称',
    dictType: '字典类型',
    value: '字典值',
    sortNo: '排序值',
    addDict: '新增字典',
    updateDict: '修改字典',
    confirmDeleteTip: '您确定删除此数据字典？',
    nameRequire: '请输入字典名称',
    typeRequire: '请输入字典类型',
    valueRequire: '请输入字典值',
    sortNoRequire: '请输入排序值'
  },
  announcement: {
    id: '#',
    title: '标题',
    content: '公告内容',
    validDate: '有效时间',
    modifiedDate: '修改时间',
    modifiedBy: '修改者',
    createdDate: '发布时间',
    createdBy: '创建者',
    addDict: '新增公告',
    updateDict: '修改公告',
    beginTime: '开始',
    endTime: '结束',
    effectTime: '开始',
    expirationTime: '结束',
    addAnnouncement: '添加公告',
    deleteSure: '您确定要删除该条公告？',
    modifyAnnouncemnet: '修改公告',
    choiceTime: '选择日期时间',
    announcementStatus: '是否发布',
    inputTitle: '请输入标题',
    inputContent: '请输入内容',
    inputTime: '请输入时间',
    titleMaxLength: '最大长度为50',
    contentMaxLength: '最大长度为500',
    nameMaxLength: '最大长度为30',
    announcementDetal: '公告详情',
    status: '状态',
    annRelease: '已发布',
    annNotRelease: '未发布',
    releaseSuccess: '发布成功',
    releaseFail: '发布失败'
  },
  advice: {
    id: '#',
    advice: '建议内容',
    reply: '回复内容',
    replyBy: '回复者',
    replyDate: '回复时间',
    status: '回复状态',
    createdDate: '创建时间',
    createdBy: '创建者',
    createTime: '创建时间',
    beginTime: '创建时间',
    endTime: '结束时间',
    replayStatus: '回复状态',
    replied: '已回复',
    noReply: '未回复',
    all: '全部',
    replayBtn: '回复',
    deleteBtn: '删除',
    addAdvice: '我要反馈',
    adviceContent: '建议内容',
    adviceReplay: '建议回复',
    advContent: '建议内容',
    replayContent: '回复内容',
    deleteSure: '确认删除这条建议吗？'
  },
  loginLog: {
    loginLog: '登录日志',
    loginFailLog: '登录失败日志',
    exitLog: '退出日志',
    account: '账号',
    time: '时间',
    details: '详情',
    source: '来源'
  },
  operatorLog: {
    logName: '日志名称',
    operatorLog: '操作日志',
    exceptionLog: '异常日志',
    account: '账号',
    className: '操作类名',
    methodName: '操作方法',
    msg: '具体消息',
    result: '操作结果',
    costTime: '耗时(ms)',
    time: '时间'
  },
  account: {
    accountInfo: '账号信息',
    modifyPwd: '修改密码',
    loginOut: '退出登录',
    account: '账号',
    oldPwd: '原密码',
    newPwd: '新密码',
    confirmNewPwd: '确认新密码',
    oldPwdRequire: '请输入原密码',
    newPwdRequire: '请输入新密码',
    confirmNewPwdRequire: '请再次输入新密码',
    newEqualOld: '新密码与原密码一样',
    newNotEqualNew: '两次密码输入不一样',
    modifyPwdSuccess: '修改密码成功！',
    newPasswordLength: '长度必须在8到16位密码之间',
    mustContain: '必须包含数字和字母'
  },
  dstConfig: {
    colHeaderTip: '如果结束年份为N/A,则表示永久有效',
    dstName: '名称',
    timezone: '时区',
    startTime: '开始时间',
    endTime: '结束时间',
    startYear: '开始年份',
    endYear: '结束年份',
    dstNameRequire: '请输入夏令时名称',
    timezoneRequire: '请输入时区',
    startTimeRequire: '请输入开始时间',
    endTimeRequire: '请输入结束时间',
    startYearRequire: '请输入开始年份',
    endYearRequire: '请输入结束年份',
    active: '状态',
    addDstConfig: '新增夏令时配置',
    updateDstConfig: '修改夏令时配置',
    confirmDeleteTip: '您确定删除此夏令时规则？',
    startTimeDesc:
        '格式为：MMIIWWHH, MM:月, II:第几个星期(01:表示第一个星期, 02:表示第二个星期, 03:表示第三个星期, 04:表示第四个星期, 11:表示倒数第一个星期), WW:星期, HH:小时',
    endTimeDesc: '为空时，则表示永久有效'
  },
  enterprise: {
    orgType: '组织架构类型',
    orgList: '组织架构列表',
    org: '组织架构',
    userManagement: '管理员',
    orgDetail: '组织架构详情',
    deviceAssignment: '设备分配',
    organizationTypeId: '组织架构类型',
    orgCode: '部门编码',
    orgName: '部门名称',
    orgManager: '部门管理者',
    parentOrganizationCode: '上级部门编码',
    parentOrganizationName: '上级部门名称'
  },
  enterprisedashboard: {
    clockStatus: '设备状态统计',
    employeeUpdate: '员工状态统计'
  },

  employee: {
    employeeList: '员工列表',
    employeeDetail: '员工信息详情',
    employeeNo: '工号',
    reqEmployeeNo: '请输入工号',
    lastName: '名',
    reqLastName: '请输入姓',
    firstName: '姓',
    reqFirstName: '请输入名',
    formattedName: '姓名',
    photo: '照片',
    gender: '性别',
    email: '邮箱',
    phone: '手机号',
    status: '状态',
    active: '激活',
    employeeBasicInfo: '基础信息',
    employeeAttInfo: '检验信息',
    assignment: '设备分配',
    badgeNo: '卡号',
    devicePassword: '设备密码',
    verifyingMode: '验证方式',
    devicePermission: '设备权限',
    hireDate: '入职日期',
    currentDept: '当前部门共计{0}人',
    totalUser: '共计{0}人',
    addEmployee: '添加员工',
    updateEmployee: '更新员工',
    selectOrgTip: '请先选择组织架构，再进行添加人员',
    deleteEmployee: '您确定要删除该员工, 是否继续?',
    downloadTemplate: '下载模板',
    importEmployee: '员工导入',
    exportEmployee: '员工导出',
    drivingStart: '驾照开始时间',
    drivingEnd: '驾照失效时间',
    enteredFingerprint: '指纹已录入',
    notEnteredFingerprint: '指纹未录入',
    enteredVisibleLight: '可见光未录入',
    enteredNirFace: '近红外已录入',
    notEnteredNirFace: '近红外未录入',
    enteredPalmPrint: '掌纹已录入',
    notEnteredPalmPrint: '掌纹外未录入'
  },
  devicePermission: { '0': '普通用户', '14': '设备管理员', '7': '现场管理员' },
  findpassword: {
    verifyAccount: '账号验证',
    verifyCode: '验证码校验',
    resetPassword: '重置密码',
    success: '找回成功'
  },
  attendanceCode: {
    laborCodes: '考勤工作代码',
    laborCodesType: '考勤工作代码类型',
    laborCodeDeatils: '考勤工作代码详情',
    newOrgCode: '新建工作代码类型',
    requireLaborCodes: '请输入考勤工作代码',
    requireLaborCodesName: '请输入考勤工作代码名称',
    requirelaborCodesType: '请输入考勤空座代码类型',
    requireLaborCodesTypeName: '请输入考勤工作代码类型名称',
    attendanceCodeList: '考勤工作代码列表',
    code: '考勤工作代码',
    assignment: '设备分配',
    unBindWordCode: '您确定解除绑定关系?'
  },
  devicesCommand: {
    comId: 'Id',
    sn: '序列号',
    imme: '是否紧急',
    protocol: '协议',
    content: '内容',
    committime: '生成时间',
    returnTime: '回复时间',
    status: '状态',
    returnValue: '回复值',
    status0: '未取走',
    code: 'Code',
    status1: '已取走未回复',
    status2: '已回复',
    status3: '已清除',
    result: '结果',
    success: '成功',
    fail: '失败',
    commandResult: '结果',
    all: '全部',
    ratchResend: '批量重发',
    sendCommandsTip: '共选中 {length}条命令，是否对选中的命令重新发送?',
    sendCommandTip: '是否重新发送该命令?'
  },
  contry: {
    AD: '安道尔共和国',
    AE: '阿拉伯联合酋长国',
    AF: '阿富汗',
    AG: '安提瓜和巴布达',
    AI: '安圭拉岛',
    AL: '阿尔巴尼亚',
    AM: '亚美尼亚',
    AO: '安哥拉',
    AR: '阿根廷',
    AT: '奥地利',
    AU: '澳大利亚',
    AZ: '阿塞拜疆',
    BB: '巴巴多斯',
    BD: '孟加拉国',
    BE: '比利时',
    BF: '布基纳法索',
    BG: '保加利亚',
    BH: '巴林',
    BI: '布隆迪',
    BJ: '贝宁',
    BL: '巴勒斯坦',
    BM: '百慕大群岛',
    BN: '文莱',
    BO: '玻利维亚',
    BR: '巴西',
    BS: '巴哈马',
    BW: '博茨瓦纳',
    BY: '白俄罗斯',
    BZ: '伯利兹',
    CA: '加拿大',
    CF: '中非共和国',
    CG: '刚果',
    CH: '瑞士',
    CK: '库克群岛',
    CL: '智利',
    CM: '喀麦隆',
    CN: '中国',
    CO: '哥伦比亚',
    CR: '哥斯达黎加',
    CS: '捷克',
    CU: '古巴',
    CY: '塞浦路斯',
    CZ: '捷克',
    DE: '德国',
    DJ: '吉布提',
    DK: '丹麦',
    DO: '多米尼加共和国',
    DZ: '阿尔及利亚',
    EC: '厄瓜多尔',
    EE: '爱沙尼亚',
    EG: '埃及',
    ES: '西班牙',
    ET: '埃塞俄比亚',
    FI: '芬兰',
    FJ: '斐济',
    FR: '法国',
    GA: '加蓬',
    GB: '英国',
    GD: '格林纳达',
    GE: '格鲁吉亚',
    GF: '法属圭亚那',
    GH: '加纳',
    GI: '直布罗陀',
    GM: '冈比亚',
    GN: '几内亚',
    GR: '希腊',
    GT: '危地马拉',
    GU: '关岛',
    GY: '圭亚那',
    HK: '香港特别行政区',
    HN: '洪都拉斯',
    HT: '海地',
    HU: '匈牙利',
    ID: '印度尼西亚',
    IE: '爱尔兰',
    IL: '以色列',
    IN: '印度',
    IQ: '伊拉克',
    IR: '伊朗',
    IS: '冰岛',
    IT: '意大利',
    JM: '牙买加',
    JO: '约旦',
    JP: '日本',
    KE: '肯尼亚',
    KG: '吉尔吉斯坦',
    KH: '柬埔寨',
    KP: '朝鲜',
    KR: '韩国',
    KT: '科特迪瓦共和国',
    KW: '科威特',
    KZ: '哈萨克斯坦',
    LA: '老挝',
    LB: '黎巴嫩',
    LC: '圣卢西亚',
    LI: '列支敦士登',
    LK: '斯里兰卡',
    LR: '利比里亚',
    LS: '莱索托',
    LT: '立陶宛',
    LU: '卢森堡',
    LV: '拉脱维亚',
    LY: '利比亚',
    MA: '摩洛哥',
    MC: '摩纳哥',
    MD: '摩尔多瓦',
    MG: '马达加斯加',
    ML: '马里',
    MM: '缅甸',
    MN: '蒙古',
    MO: '澳门',
    MS: '蒙特塞拉特岛',
    MT: '马耳他',
    MU: '毛里求斯',
    MV: '马尔代夫',
    MW: '马拉维',
    MX: '墨西哥',
    MY: '马来西亚',
    MZ: '莫桑比克',
    NA: '纳米比亚',
    NE: '尼日尔',
    NG: '尼日利亚',
    NI: '尼加拉瓜',
    NL: '荷兰',
    NO: '挪威',
    NP: '尼泊尔',
    NR: '瑙鲁',
    NZ: '新西兰',
    OM: '阿曼',
    PA: '巴拿马',
    PE: '秘鲁',
    PF: '法属玻利尼西亚',
    PG: '巴布亚新几内亚',
    PH: '菲律宾',
    PK: '巴基斯坦',
    PL: '波兰',
    PR: '波多黎各',
    PT: '葡萄牙',
    PY: '巴拉圭',
    QA: '卡塔尔',
    RO: '罗马尼亚',
    RU: '俄罗斯',
    SA: '沙特阿拉伯',
    SB: '所罗门群岛',
    SC: '塞舌尔',
    SD: '苏丹',
    SE: '瑞典',
    SG: '新加坡',
    SI: '斯洛文尼亚',
    SK: '斯洛伐克',
    SL: '塞拉利昂',
    SM: '圣马力诺',
    SN: '塞内加尔',
    SO: '索马里',
    SR: '苏里南',
    ST: '圣多美和普林西比',
    SV: '萨尔瓦多',
    SY: '叙利亚',
    SZ: '斯威士兰',
    TD: '乍得',
    TG: '多哥',
    TH: '泰国',
    TJ: '塔吉克斯坦',
    TM: '土库曼斯坦',
    TN: '突尼斯',
    TO: '汤加',
    TR: '土耳其',
    TT: '特立尼达和多巴哥',
    TW: '台湾省',
    TZ: '坦桑尼亚',
    UA: '乌克兰',
    UG: '乌干达',
    US: '美国',
    UY: '乌拉圭',
    UZ: '乌兹别克斯坦',
    VC: '圣文森特岛',
    VE: '委内瑞拉',
    VN: '越南',
    YE: '也门',
    YU: '南斯拉夫',
    ZA: '南非',
    ZM: '赞比亚',
    ZR: '扎伊尔',
    ZW: '津巴布韦'
  },
  tenantDashboard: {
    tenants: '企业信息统计',
    newEnrolled: '新增企业',
    inactive: '未激活'
  },
  dashboard: {
    dataFormste: '{value} 天',
    onlineDevice: '在线设备数',
    offLineDevice: '离线设备数',
    disableDevice: '禁用设备数',
    deviceTypetop10: '设备型号TOP10',
    addDeviceBar: '新增设备折线图',
    areaDeviceTop10: '区域设备TOP10',
    globalDeviceDis: '全球设备分布',
    addDevice: '新增设备',
    device: '设备'
  },
  apiLog: {
    mid: 'Mid',
    companyUser: '集成账号',
    requestMessage: '请求消息体',
    responseMessage: '返回体',
    ip: 'ip',
    createDate: '调用时间',
    requestResult: '请求结果',
    result: '请求结果',
    useTime: '耗时(ms)',
    url: 'API路径',
    apiLog: 'API 日志详情',
    requestTime: '调用时间',
    appKey: 'AppKey',
    success: '成功',
    fail: '失败',
    apiName: '接口名称',
    elapsedMs: '耗时',
    requestContent: '请求消息体',
    statusCode: '请求状态码',
    copySucess: '复制成功',
    copyError: '不支持复制,该浏览器不支持自动复制',
    copy: '复制',
    appCode: 'appCode',
    dbs: 'Smart  DBS',
    cc: '控制中心',
    ufo: '固件升级',
    appName: '应用名称',
    method: '请求方式',
    integrationUser: 'API用户名'
  },
  datapush: {
    appList: '应用列表',
    dataList: '数据列表',
    pushLoad: '正在推送数据',
    message: '数据内容',
    lastPushTime: '最后推送时间',
    num: '已推送次数',
    asyPushTip: '数据正异步推送中',
    pushbtnTip: '应用中转数据的异步推送',
    sid: '推送事件',
    mid: 'Mid',
    total: '总共',
    success: '成功',
    fail: '失败',
    pushURL: '推送地址',
    dataType: '数据类型',
    dataPeriod: '数据保留时间',
    lastPushStatus: '最后推送状态'
  },
  goBack: '返回上一页',
  goLoginPage: '登录页面',
  orgTree: {
    parentCode: '上级部门编码',
    parentCodeTip: '请输入上级部门编码',
    parentName: '上级部门名称',
    parentNameTip: '请输入上级部门名称',
    deptCode: '部门编码',
    deptCodeTip: '请输入部门编码',
    deptName: '部门名称',
    deptNameTip: '请输入部门名称',
    add: '添加部门',
    update: '更新部门',
    execute: '执行中...',
    createOrg: '组织架构创建成功!',
    updateOrg: '组织架构更新成功!',
    ownerDept: '所属部门'
  },
  header: {
    enterCompanyName: '请输入企业名称',
    enterAppName: '请输入应用名称',
    online: '已上线',
    offline: '已下线',
    selectApp: '请选择应用',
    all: '全部',
    createApp: '创建应用',
    selectCompany: '请选择企业',
    createCompany: '创建企业',
    companyCode: '企业编号',
    companyName: '企业名称',
    reqName: '请输入企业名称',
    reqNo: '请输入企业编号'
  },
  configType: {
    pushType: '推送类型',
    name: '名称',
    toPush: '是否推送',
    turnOn: '开启',
    turnOff: '关闭',
    desc: '描述',
    operate: '操作',
    only: '推送消息类型唯一标识',
    queue: '队列',
    sort: '排序',
    reqName: '请输入名称',
    reqSid: '请输入sid',
    maxLength: '最大长度为50字',
    reqQueue: '请选择队列',
    addConfig: '添加配置',
    updateConfig: '更新配置',
    deleteConfig: '删除此项将会关闭所有应用的此类型的消息推送，确定删除吗'
  },
  developer: {
    randomNote: '密钥组成部分，用于生成数字签名摘要',
    randomNote16: '密钥用于加密数据推送的请求内容',
    pushIntroduce: '允许DBS将数据推送到您链接的系统服务',
    companyNum: '企业数',
    employeNum: '员工数',
    paramsCongig: '参数配置',
    immCreate: '立即创建',
    noApp: '你还没有应用哦，快来创建吧！',
    appNumber: '应用数量',
    dicTypePla: '请输入字典名类型',
    dicNamePla: '请输入字典名',
    enterApp: '进入应用',
    deleteApp: '删除应用',
    withdrawApp: '撤回应用',
    withdrawTip: '确定撤回该应用吗',
    withdrawAppSuccess: '撤回成功',
    destroyApp: '销毁应用',
    destroyAppSuccess: '销毁成功',
    destroySure:
        '应用销毁后所关联数据(设备数、企业数)将会直接被删除且不可恢复，是否删除？',
    WithdrawSure: '撤回应用后将会回到应用列表中去，是否撤回?',
    name: '应用名称',
    dashboard: '仪表盘',
    appDeatil: '应用详情',
    pushSetting: '推送配置',
    dataTransferStation: '数据中转站',
    apiLog: 'API 日志',
    deviceTotle: '设备总数',
    offlineCount: '离线设备数',
    onLineCount: '在线设备数',
    relayNum: '中转站消息数',
    selectDataType: '请选择数据类型',
    goAppList: '返回应用列表',
    cancel: '取消',
    cancelWithdrawApp: '撤销取消',
    goback: '返回',
    selectType: '请选择类型',
    companyAdmin: '企业管理员',
    companySettingDes:
        '平台授权开发者在企业下创建管理该企业的账号。该账号可登录平台，并管理企业、人员与设备等操作。默认不开启。',
    appFnSetting: '应用设置',
    pushDes: '描述：',
    changeWay: '切换方式',
    appDes: '应用描述',
    newsSub: '消息订阅',
    dataTransfer: '数据中转站',
    abnormalRemind: '异常提醒',
    remindSet: '提醒设置',
    remindSet1: '小时内消息堆积超过',
    remindSet2: '条时',
    apiReport: 'API报表',
    receiveMail: '接收邮箱',
    statisticsRemind: '统计提醒',
    statisticsReport: '报表统计',
    daily: '日报',
    dailyTips: '日报数据为前一日数据统计',
    week: '周报',
    weekTips: '周报数据为前一周数据统计，每周一推送',
    month: '月报',
    monthTips: '月报数据为前一月数据统计，每月1号推送',
    mailSetMax: '接收邮箱数已经达到极限',
    appName: '应用名称',
    developerAccount: '开发者账号',
    assApplication: '已关联的应用',
    config: '配置',
    newEmail: '新邮箱',
    changeEmail: '变更邮箱',
    isOk: '好 的',
    createAppSucess: '创建成功！',
    visiable: '可见',
    disvisible: '不可见',
    updateApp: '更新应用',
    deleteTips:
        '删除应用后将进入回收站，如需清除该应用数据，请前往回收站进行销毁，是否删除？',
    lastQuest: '最近活跃时间',
    aeskeyPla: '请输入加密秘钥',
    tokenPla: '请输入token',
    desPla: '请输入应用描述',
    phonePla: '请输入手机号',
    contactPerPla: '请输入联系人',
    appEmailPla: '请输入邮箱',
    appNamePla: '请输入应用名称',
    appList: '应用列表',
    appInfo: '应用详情',
    details: '应用基础信息',
    setting: '配置',
    addApp: '创建应用',
    deleApp: '删除应用',
    id: '应用id',
    code: '验证码',
    des: '应用描述',
    contactPerson: '联系人',
    mail: '邮箱',
    phone: '手机号',
    appKey: 'AppKey',
    appSecret: 'AppSecret',
    pushDerail: '推送开关',
    url: 'URL',
    token: 'Token',
    aeskey: '加密秘钥',
    aesStatus: '是否加密',
    eventTypeArray: '需要推送的数据类型',
    serviceConfig: '推送配置',
    requireName: '请输入应用名称',
    requireMail: '请输入邮箱',
    appNameLength: '长度最长为16字符',
    requireCode: '请输入验证码',
    randomCode: '随机获取',
    reset: '重置',
    saveTip: '正在保存',
    resetTip: '您确定要重置appSecret吗?',
    pushPunchRecordFunOn: '打卡记录',
    pushPhoto: '考勤照片',
    pushDeviceInitFunOn: '设备初始化',
    pushRegisterFpTipFunOn: '指纹登记',
    pushDeviceStatusFunOn: '设备状态',
    validateUrl: '校验URL',
    urlTip: '请输入有效的URL',
    urlEg: '例如：https://www.zkteco.com/',
    emainValidate: '请输入正确的邮箱地址'
  },
  doc: {
    apiDoc: '接口文档',
    faq: 'FAQ(常见问题集)',
    version: '版本信息',
    operate: '操作手册',
    tenant: '托管方操作手册',
    developer: '开发者操作手册',
    enterpriseAdmin: '企业管理操作手册'
  },
  operationMsg: {
    uploadSuc: '上传成功',
    updateSuc: '修改成功',
    bindSuc: '绑定成功',
    addSuc: '添加成功',
    sendSuc: '发送成功',
    importSuc: '导入成功',
    deleteSuc: '删除成功'
  },
  sysTemplate: {
    type: '类型',
    title: '标题',
    templateName: '模板名称',
    content: '内容',
    group: '所属分组',
    languange: '语言',
    satatus: '状态',
    create: '创建者',
    createData: '创建日期',
    update: '修改者',
    updateData: '修改日期',
    delteTemplate: '您确定删除该模版, 是否继续?',
    editTemp: '模板编辑',
    viewTemp: '模板预览',
    addTemp: '新增模板',
    tempTips1:
        '模板示例：{1}为您的登录验证码，请于{2}分钟内填写。如非本人操作，请忽略本短信。',
    tempTips2:
        '（其中{数字}为可自定义的内容，须从0开始连续编号 ，如{0}、{1}等）',
    sign: '签名',
    inputCode: '请输入模板code',
    inputType: '请输入模板类型',
    inputLang: '请输入模板语言',
    inputName: '请输入模板名称',
    inputTitle: '请输入模板标题',
    inputContent: '请输入模板内容',
    inputGroup: '请输入模板分组'
  },
  wxbind: {
    unbindWx: '微信解绑',
    unbindWxTips: '您将解绑该账号，是否继续？',
    bindPhoneSuc: '手机绑定成功'
  },
  integrators: { addIntegrators: '新增账号', confirmFreeze: '冻结用户' },
  center: {
    isGoOn: '继续',
    isNotBind: '您还未绑定邮箱，请在个人中心先绑定邮箱',
    disposeAccountTips:
        '该操作将注销您的账号，注销后，您将无法再次登录，SmartDBS也将清空账号相关的所有数据，请谨慎操作。',
    deal: '隐私协议',
    policy: '隐私权政策',
    clickShow: '点击查看',
    disposeAccount: '注销账号',
    verPhone: '请输入正确的手机号',
    weakPwd: '您使用的密码不包含数字和字母，请重新设置！',
    centerpage: '个人中心',
    basicInfo: '基本信息',
    socialAccount: '社交账号绑定',
    noBindEmail: '未绑定邮箱',
    noBindPhone: '未绑定手机',
    valWay: '更换手机/邮箱需要进行身份验证',
    valEmail: '邮箱验证',
    valPhone: '手机验证',
    reGetCode: '秒',
    getCode: '获取验证码',
    code: '验证码',
    plaCode: '请输入验证码',
    plaPhone: '请输入手机号',
    plaSureEmail: '请输入正确的邮箱地址',
    plaEmail: '请输入邮箱地址',
    auth: '身份验证',
    updateNicknameSuc: '昵称修改成功',
    plaContent: '请输入内容',
    updateWetchat: '解除微信',
    nobindWetchat: '未绑定,点击',
    updatePassword: '修改密码',
    updatePhone: '修改手机',
    bindPhone: '绑定手机',
    updateEamil: '修改邮箱',
    bindEmail: '绑定邮箱',
    bindWetchat: '绑定微信',
    password: '密码',
    phone: '手机',
    email: '邮箱',
    headImg: '头像',
    nickName: '昵称',
    account: '账号',
    wetchat: '微信',
    expirationDate: '有效期限'
  },
  appSetting: { deviceCommand: '设备命令' },
  pushStation: { errorRecord: '异常记录' },
  deviceEmp: {
    bindEmp: '绑定人员',
    deviceBindEmp: '设备人员绑定',
    orgTree: '组织架构',
    empList: '人员列表',
    selectDevice: '请选择设备',
    unbindDevice: '此操作将设备进行解绑, 是否继续?',
    unbindSuc: '设备解绑成功',
    unbindCan: '已取消解绑',
    hasDevice: '请确认是否存在设备'
  },
  empList: {
    lostImport: '批量导入',
    choiseFile: '选择文件',
    extName: '支持扩展名',
    extTip: '.xlsx或.xls',
    finishImport: '批量导入完成',
    beginImport: '开始导入',
    finish: '完成',
    onlyXLSL: '仅支持.xlsl的文件格式'
  },
  attRecord: { temperature: '温度', hasMask: '是否佩戴口罩' },
  companyList: {
    selectApp: '请选择应用',
    deletCompany: '此操作将永久删除该企业, 是否继续?'
  },
  annList: {
    sendEmail: '发送邮件',
    dev: '第三方开发者',
    ent: '企业管理员',
    sureRelase: '您确定发布该系统公告？'
  },
  com_log: {
    tipMsg: '列表包括了过去三十天内设备通讯活动的支持服务',
    nearlyDays7: '近7天',
    search: '搜索',
    eventTime: '事件时间',
    protocol: '协议',
    sn: 'SN',
    type: '事件类型',
    mid: 'Message ID',
    funcName: '功能名称',
    loadMore: '点击加载更多',
    content: '内容',
    associatedLog: '关联日志',
    result: '结果',
    success: '成功',
    fail: '失败',
    inputSn: '请输入SN',
    inputMid: '请输入Message ID',
    selectProtocol: '请选择协议',
    selectEventType: '请选择事件类型',
    selectFuncName: '请选择功能名称',
    selectResult: '请选择结果'
  },
  device: {
    memoryRemaining: '剩余内存',
    storageRemaining: '剩余存储空间',
    com_log: '通讯日志',
    uploadAtt: '上传考勤记录',
    uploadUserInfo: '上传用户信息',
    synData: '同步人员信息',
    network: '网络连接',
    deviceUser: '设备用量',
    deviceCommand: '设备命令',
    deviceSelectPla: '请选择设备状态',
    deviceSetting: '设备设置',
    deviceParamsDesc: '参数描述',
    deviceNum: '设备数（在线/总数）',
    firmwareUpgrade: '固件升级',
    snycUser: 'DBS将推送人员信息到设备中，并覆盖设备数据，是否继续？',
    uploadUser: '设备内的人员信息将上传到DBS，是否继续？',
    hasNODevice: '暂无设备，不可操作!',
    sn: '序列号',
    name: '设备型号',
    alias: '设备名称',
    deviceList: '设备列表',
    deviceDetails: '设备详情',
    deviceInfo: '设备信息',
    deviceConInfo: '网络连接',
    deviceRunSysInfo: '设备系统信息',
    addDevice: '添加设备',
    modifyDevice: '修改设备',
    snRequire: '请输入序列号',
    maxLength: '最大长度为35',
    maxLength20: '最大长度为20',
    devAlais: '请输入设备名称',
    assignDevice: '分配设备',
    selectDeivces: '选择设备',
    selectUnBindDevice: '请选择解绑的设备',
    selectDept: '请选择要绑定的组织架构',
    unBindDept: '您确定解除绑定关系?',
    unBindBtn: '解除绑定',
    setEmployeeBind: '您确定当前员工绑定选中的设备?',
    deviceOperate: '设备操作',
    confirmDeleteTip: '您确定删除此设备？',
    deleteBioTemplate: '您确定要删除模板？',
    deviceModel: '设备型号',
    deviceTimezone: '时区',
    active: '激活',
    connectionMode: '网络模式',
    localIp: '内网IP',
    macAddress: '物理地址',
    remoteIp: '公网IP',
    ipLocation: '地址',
    firmwave: '固件版本',
    commProtocol: '协议',
    commProtocolVer: '协议版本',
    systemPlatform: '操作系统',
    osVersion: '操作系统版本',
    storageSize: '内存大小',
    storageFreeSize: '剩余内存',
    employeeCount: '员工数',
    fpCount: '指纹数',
    faceCount: '人脸数',
    fvCount: '近红外面部',
    attlogCount: '记录数',
    lastRequest: '最后请求时间',
    status: '在线状态',
    totalDevice: '总数',
    online: '在线',
    disbaleDevice: '禁用',
    offLine: '离线',
    reboot: '您确认重启设备?',
    disabled: '您确认禁用设备?',
    dataRange: '时间范围',
    uploadAttData: '上传考勤数据',
    code: '考勤工作代码',
    Timezone: '设备时区',
    deviceStatus: '启用状态',
    onlineStatus: '在线',
    enableStatus: '启用',
    equipmentStatus: '设备状态',
    offLineTip: '设备离线,不允许操作',
    enableTip: '设备禁用不允许操作',
    deviceEmploye: '设备人员列表',
    deviceHistoryLog: '设备操作日志',
    deviceConfig: '参数配置',
    deviceParams: '参数',
    deviceParamsValue: '值',
    noPermission: '没权限添加设备',
    deviceOptions: '设备参数详情',
    version: '版本',
    firmwaveSize: '大小',
    description: '新版本内容',
    noInfo: '没有描述信息',
    upgrade: '升级',
    retry: '重试',
    upgradeFailed: '升级失败',
    beingUpgraded: ' 您的设备正在升级中，请耐心等待',
    burningFirmware: '正在烧制固件，请耐心等待',
    upgradeSuccessful: '升级成功！',
    downloadingFirmware: '正在下载固件到您的设备中，请耐心等待',
    deviceInternet: '请确认您的设备已经通电，并且为已联网状态',
    sizeTip: '未知',
    log: {
      userName: '操作者',
      companyName: '所属企业',
      requestParams: '请求参数',
      createdDate: '日期时间',
      methodType: '操作类型'
    },
    dataOperation: '数据操作',
    removeOldData: '不清除旧数据',
    synInfo: '同步信息',
    baseInfo: '人员基本信息',
    bioTemplateInfo: '人员生物模板',
    facePhotoInfo: '人员可见光照片',
    synTip: '已提交同步信息，系统执行中，请稍后在设备中查看',
    synbtn: '同步',
    devType: '设备类型',
    deviceCategory: '设备分类',
    updateAllDevice: '升级所有设备',
    allCount: '设备总数',
    canUpgradeCount: '符合升级设备数',
    noNeedUpgradeCount: '无需升级',
    upgradingCount: '升级中',
    updateConfirm: '是否确认升级？',
    updateTip: '升级命令已下发，详情请查看升级历史',
    updateText: '设备升级中，请勿断电断网，您可以在升级历史中查看升级进度',
    updateHistory: '升级历史',
    upgrading: '升级中',
    upgradeSuccess: '升级成功',
    upgradeError: '升级失败',
    downloading: '下载中',
    fire: '烧制中',
    upgradeTimeout: '升级超时',
    updateDetails: '升级详情',
    source: '操作来源',
    lastVersion: '上一版本',
    currentVersion: '目标版本',
    biosignature: '生物特征',
    serviceUpdate: '服务端升级',
    clientUpdate: '设备端升级',
    dbsUpdate: 'DBS升级'
  },
  license: {
    curLicense: '当前许可信息',
    licenseStatus: '许可状态',
    licentseValidity: '许可有效期',
    deviceMax: '设备上限数',
    curDevice: '当前设备数',
    newsLicense: '最新许可在线申请信息',
    aduitStatus: '审核状态',
    applyDevice: '申请设备数',
    applyDate: '申请有效期',
    remark: '备注',
    approvalTime: '审批时间',
    custormInfo: '客户信息',
    custormNo: '客户端编号',
    custormContact: '联系人',
    custormPhone: '联系电话',
    custormEmail: '邮箱',
    custormCompany: '企业',
    onlineLicense: '在线申请许可',
    offlineLicense: '离线申请许可',
    importLicense: '导入许可',
    titles: '提示',
    uploadTips1: '将文件拖到此处，或',
    uploadTips2: '点击上传',
    year: '年',
    save: '保存',
    reset: '重置',
    noUpdate: '不修改客户信息，直接跳过',
    tips: '温馨提醒：预申请信息仅供审核时参考，具体以审核设置的数据为准。',
    updateTips:
        '温馨提醒：将此【许可申请码】复制发给许可管理员索要许可文件，将其导入即可完成许可升级。',
    deviceNum: '设备数',
    apply: '有效期',
    applyCode: '许可申请码',
    copy: '一键复制到剪贴板',
    inputContant: '请输入联系人',
    inputPhone: '请输入手机号码',
    inputEmail: '请输入邮箱地址',
    inputCompany: '请输入企业名称',
    inputDevice: '请输入设备数',
    inputApply: '请输入有效期',
    copySuc: '已复制到剪切板',
    applySuc: '成功申请'
  },
  statistics: {
    lastSevenDays: '最近7天',
    lastMonth: '最近一个月',
    lastThreeMonths: '最近三个月',
    more: '查看更多',
    apiSort: '接口调用排行',
    apiStatistics: '接口调用量统计',
    todayCallsTotal: '今日接口调用总量',
    todayCallsSort: '今日接口调用排行',
    today: '今天',
    months: {
      month01: '一月',
      month02: '二月',
      month03: '三月',
      month04: '四月',
      month05: '五月',
      month06: '六月',
      month07: '七月',
      month08: '八月',
      month09: '九月',
      month10: '十月',
      month11: '十一月',
      month12: '十二月'
    },
    url: 'API 路径',
    apiName: 'API 名称',
    callCount: '调用次数',
    interfaceCallCount: '接口调用次数',
    callDetail: '调用详情',
    appKey: 'AppKey',
    appName: 'APP 名称',
    callTimes: '调用: {count} 次',
    apiCallDetail: 'Api 调用详情',
    appCallDetail: 'APP 调用详情',
    name: '名称'
  },
  accManager: {
    doorName: '门名称',
    devAlias: '所属设备',
    devStatus: '状态',
    doorList: '门列表',
    timeSlot: '门禁时间段',
    permissionGroup: '门禁权限组',
    timezoneName: '时间段名称',
    timeSlotDetails: '时间段详情',
    holiday1: '节假日一',
    holiday2: '节假日二',
    holiday3: '节假日三',
    groupName: '权限组名称',
    timezone: '时间段',
    distributionDoor: '门分配',
    distributionPersonnel: '人员分配',
    number: '编号',
    name: '名称',
    daterange: '日期'
  },
  successOperation: {
    delete: '删除成功',
    add: '新增成功',
    sendCode: '验证码已发送',
    sendEmail: '成功发送邮件',
    reset: '重置成功',
    update: '更新成功',
    cancellationSuccess: '注销成功'
  },
  errorOperation: {},
  warningOperation: { hasPhoneOrEmail: '您未绑定手机或者邮箱，请先绑定' },
  operation: {
    addNew: '新增',
    save: '保存',
    confirm: '确认',
    saving: '正在保存...',
    checkAll: '全选',
    search: '搜索',
    freeze: '冻结',
    unfreeze: '解冻'
  },
  attendanceRecord: {
    exportRecord: '导出',
    device: '设备',
    employee: '员工',
    pin: '工号',
    sn: '序列号',
    deviceName: '设备名称',
    to: '至',
    checktime: '打卡时间',
    workcode: '考勤工作代码',
    dataRange: '操作时间',
    commitTime: '生成时间',
    punchTime: '打卡时间',
    lastweek: '最近一周',
    lastmonth: '最近一个月',
    lastThreeMonths: '最近三个月',
    exportResult: '导出搜索结果',
    exportAll: '导出全部',
    verifyPhoto: '核验照片',
    view: '查看'
  },
  witnessRecord: {
    checkRecord: '核验记录',
    personRecord: '人证记录',
    checkFail: '核验失败',
    checkSuccess: '核验成功',
    bornPerson: '禁止人员',
    checkTime: '核验时间',
    checkResult: '校验结果',
    employeeNo: '人员编号',
    normalTemperature: '体温正常',
    abnormalTemperature: '体温异常',
    deviceSn: '设备序列号',
    temperature: '温度',
    hasMask: '是否佩戴口罩',
    yes: '确 认',
    no: '取 消',
    checkMode: '验证方式',
    name: '姓名',
    beginEndTime: '起始时间',
    accEvent: '门禁事件',
    operatorPerson: '操作人员',
    normalEvent: '正常事件',
    warnEvent: '警告事件',
    abnormalEvent: '异常事件',
    doorNum: '门编号',
    time: '时间',
    outInStatus: '出入状态',
    doorEvent: '门禁事件'
  },
  verifyintModel: {
    '0': '指静脉/人脸/指纹/卡/密码 (自动识别)',
    '1': '仅指纹',
    '2': '工号验证 ',
    '3': '仅密码 ',
    '4': '仅卡 ',
    '5': '指纹/密码 ',
    '6': '指纹/卡 ',
    '7': '卡或密码 ',
    '8': '工号+指纹 ',
    '9': '指纹+密码 ',
    '10': ' 卡+指纹 ',
    '11': ' 卡+密码 ',
    '12': ' 指纹+密码+卡 ',
    '13': ' 工号+指纹+密码 ',
    '14': ' 工号+指纹 / 卡+指纹 ',
    '15': ' 人脸 ',
    '16': ' 人脸+指纹 ',
    '17': ' 人脸+密码 ',
    '18': ' 人脸+卡 ',
    '19': ' 人脸+指纹+卡 ',
    '20': ' 人脸+指纹+密码 ',
    '21': ' 指静脉',
    '22': ' 指静脉+密码',
    '23': ' 指静脉+卡 ',
    '24': ' 指静脉+密码+卡 ',
    '25': ' 掌纹 ',
    '26': ' 掌纹+卡',
    '27': ' 掌纹+面部',
    '28': ' 掌纹+指纹 ',
    '29': ' 掌纹+指纹加面部 ',
    '30': '仅身份证',
    '31': '身份证+人脸',
    '32': '身份证+人脸+可信',
    '33': '身份证+指纹+人脸',
    '34': '仅可信认证',
    '200': ' 其他',
    BioDataCount: '人脸模板(可见光)',
    FingerCount: '指纹模板',
    FaceCount: '人脸模板(近红外)'
  },
  company: {
    apiUserTips: '使用API时的必传参数，作为调用接口的唯一标识',
    loginUserTips: '使用API时的必传参数，校验企业账号的合法性',
    entryCompany: '进入企业',
    selectCountry: '请先选择国家',
    updateInfo: '更新企业信息',
    devList: '设备列表',
    cmpInfo: '企业信息',
    logo: 'logo',
    dataFormat: '日期格式化',
    timeFormate: '时间格式化',
    language: '语言',
    state: '省份',
    country: '国家',
    zipCode: '邮编',
    city: '城市',
    email: '邮箱',
    phone: '电话',
    address: '地址',
    active: '激活状态',
    agentCode: '代理商编码',
    integrator: '集成者',
    enable: '是否可用',
    webSite: '网站',
    name: '名称',
    code: '企业编号',
    type: '类型',
    accountInfo: '基本信息',
    companyContactInfo: '联系信息',
    Contact: '联系人',
    preference: '偏好信息',
    address1: '街道1',
    address2: '街道2',
    address3: '街道3',
    status: '状态',
    Integrator: '集成商',
    industry: '所属行业',
    createdDate: '创建时间',
    modifiedDate: '修改时间',
    employeeList: '人员列表',
    assEquipment: '关联设备',
    accAuthority: '门禁权限'
  },
  tenant: {
    companyList: '企业列表',
    companyDetail: '企业详情',
    settings: '基础信息',
    accountUser: '账号管理',
    configurations: '参数设置',
    owner: '企业名称',
    parameterName: '名称',
    parameterValue: '值',
    dataConstraint: '描述',
    confirmRestoreTip: '您确认还原为默认值?',
    confirmRestore: '确认还原',
    cancelRestore: '取消还原',
    adminAccount: '管理员账号',
    integrationAccount: '集成账号',
    device: '设备'
  },
  sysOption: {
    deleteParams: '是否删除该事件类型？',
    updateDeviceParams: '更新设备参数',
    addDeviceParams: '新增设备参数',
    dictionaryType: '字典类型',
    paramsValueType: '参数值类型',
    isAllowModify: '是否允许修改',
    onlyRead: '只读',
    readAndWrite: '读写',
    protocol: '通讯协议',
    inputDictionary: '请输入数据字典类型',
    dictionary: '字典类型',
    paramsValue: '参数值类型',
    inputConnection: '请输入关联参数',
    connect: '关联参数',
    selectWay: '请选择方式',
    isAllow: '是否允许修改',
    inputReadWay: '请选择读写方式',
    readWay: '读写状态',
    inputSaveParam: '请输入存储名称',
    saveParam: '存储名称',
    inputOriginalParams: '请输入原始参数',
    originalParam: '原始参数',
    searchProtocol: '请选择通讯协议',
    deleteEvent: '是否删除该事件类型？',
    updateAccEventType: '更新门禁事件类型',
    addAccEventType: '新增门禁事件类型',
    desc: '描述',
    inputDescValue: '请输入描述',
    inputDescName: '请输入描述名',
    eventDesc: '事件描述',
    inputStandardType: '请输入标准事件类型',
    standardType: '标准事件类型',
    inputOriginalType: '请输入原始事件类型',
    originalType: '原始事件类型',
    eventType: '请选择事件类型',
    accEventType: '门禁事件类型',
    deviceParamsType: '设备参数管理',
    desPla: '请输入描述',
    plainPla: '请输入值',
    namePla: '请输入名称',
    yes: '是',
    no: '否',
    not: '取 消',
    readonly: '是否只读',
    enable: '是否启用',
    code: '名称',
    plainVal: '值',
    tocompany: '是否同步',
    des: '描述',
    add: '新增系统参数',
    update: '修改系统参数',
    requireCode: '请输入参数名',
    requirePlainVal: '请输入参数值',
    uploadFail: '上传失败,请上传html格式且编码格式为utf-8的文件',
    selectLang: '请选择语言',
    download: '下载',
    inputFile: '请选择一个文件',
    selectFile: '选择文件',
    verLang: '选择语言',
    inputVer: '请输入版本号信息',
    version: '版本号',
    uploadFile: '上传文件',
    createTime: '创建时间',
    fileName: '文件名',
    agreeManager: '隐私协议管理'
  },
  pushlog: {
    dataType: '数据类型',
    pushResult: '推送结果',
    success: '成功',
    fail: '失败',
    pushTime: '推送时间',
    pushDetails: '推送日志详情'
  },
  cancelAccount: {
    cancelAccount: '注销账号',
    agreements: '协议与法规',
    view: '点击查看',
    developer: 'ZKBio SmartDBS开发者协议',
    privacyPolicy: 'ZKBio SmartDBS个人信息保护及隐私政策',
    dataProcess: 'ZKBio SmartDBS数据处理协议',
    withdrawal: '撤销同意',
    cancelTip:
        ' 该操作将注销您的账号，注销后，您将无法再次登录，Smart DBS也将清空账号相关的所有数据，请谨慎操作。',
    exportTip:
        '您即将注销该账号，注销后，平台将不再存储并销毁已存储的您的相关数据',
    clickHere: '点击此处',
    verificationType: '验证方式',
    changeType: '切换验证方式',
    code: '验证码',
    inputCode: '请输入验证码',
    withdraw: '注销',
    click: '点击获取',
    protocol: '协议'
  },
  exportData: {
    recordData: '记录数据',
    tip: '仅提供近一个月内',
    infoData: '信息数据',
    export: '导出',
    exportTip:
        ' 您勾选的数据将发送到指定的邮箱中，请在下方输入可正常接收邮件的邮箱。',
    inputEmail: '请输入邮箱地址',
    emainValidate: '请输入正确的邮箱地址',
    sendEmailTip: '后端正在异步处理数据，稍后请查看邮件',
    attendanceRecord: '考勤记录',
    verificationRecord: '核验记录',
    witnessRecord: '人证记录',
    companyInformation: '企业信息',
    organizationalStructure: '组织架构'
  },
  alcoholDetectionRecord: {
    pin: '人员 ID',
    name: '人员姓名',
    dataFromDevice: '设备SN',
    date: '检测时间',
    alcoholDegree: '酒精度数',
    drivingLicense: '驾驶执照',
    healthStatus: '健康状态',
    sleepHours: '睡眠小时数',
    licesnePlateNo: '驾照编号',
    bodyTemparature: '体温',
    confirm: '确认',
    comment: '备注'
  },
  licensePlate: {
    num: '驾照号',
    alias: '别名',
    employeeNo: '车牌号',
    reqLicensePlateNo: '请输入您的工作编号',
    lastName: '姓',
    reqLastName: '请输入姓氏',
    firstName: '名',
    reqFirstName: '请输入名字',
    formattedName: '名',
    photo: '照片',
    gender: '性别',
    email: '邮箱',
    phone: '手机号',
    status: '状态',
    active: '激活',
    employeeBasicInfo: '基础信息',
    employeeAttInfo: '核验信息',
    assignment: '设备分配',
    badgeNo: '卡号',
    devicePassword: '密码',
    verifyingMode: '验证方式',
    devicePermission: '权限',
    hireDate: 'Hiredate',
    currentDept: '当前部门总数为 {0}',
    totalUser: '总数为 {0}',
    addLicensePlate: '新增车牌',
    updateLicensePlate: '更新车牌',
    selectOrgTip:
          '请在添加人员之前选择组织结构',
    deleteLicensePlate:
          '您确定要删除当前车牌吗？',
    checkImportOrganization:
          '您确定要在此处导入牌照吗?',
    downloadTemplate: '下载模板',
    importLicensePlate: '导入车牌',
    exportLicensePlate: '导出车牌'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/languages/zh_cn/cn.js